import React, { FC } from 'react';
import { ChevronRightIcon } from '@heroicons/react/24/outline';
import { Link, SVGIcon, Typography } from '@loomstateorg/shared-frontend';
import { Icons } from 'components/commercetools-ui/types';
import useClassNames from '@loomstateorg/shared-frontend/hooks/useClassNames';
import { Category } from 'types/category';

export interface Props {
  link: Category;
  categoriesNavigator?: Category[];
  onClick: () => void;
  hideHeaderMenu: () => void;
  children?: React.ReactNode;
  icon?: Icons | null;
  shouldShowIcon?: boolean;
  index?: number;
}

const MobileMenuNavButton: FC<Props> = ({
  link,
  categoriesNavigator,
  onClick,
  hideHeaderMenu,
  icon,
  shouldShowIcon,
  index = 0,
}) => {
  const linkClassNames = useClassNames([
    'flex justify-between',
    categoriesNavigator?.length === 0 ? 'py-24' : link?.categoryId === 'myAccount' ? 'pb-16' : 'pb-36',
  ]);

  return (
    <div key={link.categoryId} className="cursor-pointer" data-testid={`mobile-nav-item-${index}`}>
      {link?.subCategories && link?.subCategories?.length > 0 ? (
        <div onClick={onClick} className={linkClassNames} data-testid={`open-subcategory-${index}`}>
          <div className="flex items-center">
            {shouldShowIcon && icon && (
              <div className="mr-6 flex h-20 w-20 shrink-0 items-center justify-center">
                <SVGIcon
                  src={icon?.fields?.file?.url || ''}
                  alt={icon?.fields?.title || ''}
                  className="h-full w-full object-contain"
                />
              </div>
            )}
            <Typography className="text-16 text-primary-regular lg:text-18">{link.linkName}</Typography>
          </div>
          <ChevronRightIcon className="w-20" />
        </div>
      ) : (
        // testid-ignore: only closes the drawer when the inner link is clicked
        <div onClick={hideHeaderMenu} className={linkClassNames}>
          <Link link={link?.slug || link?.linkUrl} data-testid={`mobile-nav-page-${index}`}>
            <div className="flex items-center">
              {shouldShowIcon && icon && (
                <div className="mr-6 flex h-20 w-20 shrink-0 items-center justify-center">
                  <SVGIcon
                    src={icon?.fields?.file?.url || ''}
                    alt={icon?.fields?.title || ''}
                    className="h-full w-full object-contain"
                  />
                </div>
              )}
              <Typography className="text-16 text-primary-regular lg:text-18">{link.linkName}</Typography>
            </div>
          </Link>
        </div>
      )}
    </div>
  );
};

export default MobileMenuNavButton;
